import { render, staticRenderFns } from "./OnlineDrama.vue?vue&type=template&id=e7122d70&scoped=true&"
import script from "./OnlineDrama.vue?vue&type=script&lang=js&"
export * from "./OnlineDrama.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDrama.vue?vue&type=style&index=0&id=e7122d70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7122d70",
  null
  
)

export default component.exports